import makeStyles from '@material-ui/core/styles/makeStyles';
var useStyles = makeStyles(function () { return ({
    container: {
        width: '100%',
        height: '36px',
        padding: '0 16px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        columnGap: 8,
        boxSizing: 'border-box',
        background: 'radial-gradient(100% 100% at 50.13% 0%, #3C3C46 0%, #1B1B22 100%)',
        '& svg': {
            width: '14px',
            height: '14px',
        },
    },
    countryFlag: {
        maxHeight: '12px',
    },
    divider: {
        height: 15,
        width: 1,
        borderLeft: '1px solid rgba(142, 142, 142, 0.2);',
    },
}); }, { name: 'RoundPlate' });
export { useStyles };
